import {Dropdown} from '@/components/atoms'
import {useProductCombination} from './useProductCombination'

export const ProductCombination = () => {
  const {isVisible, values, selectedValue, handleUpdateValue} = useProductCombination()

  if (!isVisible) {
    return null
  }

  return (
    <div className="flex items-center">
      Customer{' '}
      <Dropdown
        isJsonWrap={false}
        childList={values}
        placeholder="Select a condition"
        updateValue={handleUpdateValue}
        isClearable={false}
        value={[selectedValue]}
        selection="single"
        autocomplete="off"
        style={{width: '200px', margin: '0 8px'}}
      />{' '}
      products to get the promotion.
    </div>
  )
}
